import {NO_NODE_ID} from 'common/src/components/CLCardsMap/CLCardsMap.config';
import {NodeType, OutputType} from 'common/src/modules/nodes/nodes.types';
import {ContentCardData} from '../../scratchpad/contentCardScratchpad.types';
import {sharedCampaigns} from '@cl/shared';
import {ContentFeedNode} from 'common/src/modules/decisionTree/decisionTree.types';
import {CLStore} from 'common/src/redux/store';
import {TimezoneSource} from 'common/src/modules/timezones/timezones.types';
import {UTCAbbreviation} from 'common/src/modules/timezones/timezones.consts';
import {contentSetsApi} from 'common/src/modules/contentSets/contentSets.api';
import {contentFeedsApi} from 'common/src/modules/contentFeeds/contentFeeds.api';

function createDefaultContentCard(): ContentCardData {
  return {
    id: NO_NODE_ID,
    name: 'Content Card',
    description: '',
    type: NodeType.CONTENT_FEED,
    outputs: [
      {
        id: 1,
        name: 'Fallback',
        type: OutputType.Fallback,
        nodeId: NO_NODE_ID,
      },
    ],
    inputs: [],
    nextOutputId: 1,
    contentFeedId: 0,
    contentSetId: undefined,
    contentId: undefined,
    strategy: undefined,
    configuration: undefined,
    timezoneSource: TimezoneSource.User,
    timeZone: UTCAbbreviation,
  };
}

/**
 * Gets an existing content card by ID, or creates a new default one.
 * @param cardId - The card ID to fetch, or 0/undefined for a new card
 * @returns The content card (existing or new), fully mutable
 */
async function getOrCreateContentCard(
  cardId: number | undefined,
  _store: CLStore,
): Promise<ContentCardData> {
  const resolvedCardId = cardId && cardId > NO_NODE_ID ? cardId : NO_NODE_ID;

  if (resolvedCardId) {
    const existingCard = sharedCampaigns.nodesRef.value[resolvedCardId];

    if (!existingCard) {
      throw new Error(`Card with id ${resolvedCardId} not found`);
    }

    if (existingCard.type !== NodeType.CONTENT_FEED) {
      throw new Error(`Card with id ${resolvedCardId} is not a content card`);
    }

    const contentFeedNode = existingCard as ContentFeedNode;

    const availableFeeds = await contentFeedsApi.getContentFeeds();
    const availableSets = await contentSetsApi.getContentSets(contentFeedNode.contentFeedId);

    return {
      ...contentFeedNode,
      availableFeeds: availableFeeds.map((feed) => ({
        id: feed.id,
        name: feed.name,
      })),
      availableSets: availableSets.map((set) => ({
        id: set.id,
        name: set.name,
      })),
    } as ContentCardData;
  }

  return createDefaultContentCard();
}

export default getOrCreateContentCard;
